import { useEffect, useState } from 'react'

import styles from 'styles/SectionIntroScreen.module.css'
import artWorkStyles from 'styles/UploadScreen.module.css'
import uploadIcon from 'assets/images/common/uploadIcon.svg'
import firebase from "config/firebase";
import blueLoader from 'assets/images/UploadWickScreen/blueLoader.svg'

import { sendSocketMessage } from 'config/socket/socketUtil'


import Reveal from 'reveal.js'

type UploadMp4ScreenPropType = {
    firebaseRef: any;
    studentDetails: {
      id: string;
    };
    firebaseStorage: any;
    videoRef: any;
    videoUrl: string;
    heading?: string;
    socketInstance: any;
}

function UploadMp4Screen({firebaseRef, studentDetails, firebaseStorage, heading, videoRef, videoUrl, socketInstance} : UploadMp4ScreenPropType) {

 // const [ isVideoProcessing, setIsVideoProcessing ] = useState<boolean>(false)
  const [ isFileUploading, setIsFileUploading ] = useState<boolean>(false)

  useEffect(() => {
    // socket.on('message', ({ className :lecture, id, message}: { className: string; id: string, message: any}) => {
    //   if( lecture === className && id === studentId && message.screen === "UploadMp4Screen") {
    //     setIsFileUploading(message.isFileUploading)
    //   }
    // })

    const callbackFunction = (state: any) => {
      setIsFileUploading(state.isFileUploading)
    }
    socketInstance.onMessage('UploadMp4Screen', callbackFunction)
  },[])

  // useEffect(() => {
  //   const videoProgresscallback = () => {
  //     if((DEFAULT_VIDEO_DURATION - videoRef.current.currentTime) < 8) {
  //       videoRef.current.currentTime = 0;
  //       videoRef.current.pause()
  //       videoRef.current.muted = false;
  //       socket.emit('message', {className: className, id: studentId, message: { screen: 'uploadArtWorkScreen', isVideoProcessing: false }})

  //       Reveal.next()

  //       videoRef.current.removeEventListener('timeupdate', videoProgresscallback)
  //     }
  //   }
  //   if(videoUrl) {
  //     videoRef.current.play()
  //     videoRef.current.muted = true
  //     videoRef.current.addEventListener('timeupdate', videoProgresscallback)
  //   }

  //   return () => {
  //     videoRef.current.removeEventListener('timeupdate', videoProgresscallback)
  //   }
  // }, [videoUrl])

  const triggerInput = () => {
    document.getElementById('mp4fileInput')?.click()       // triggering fileInput
  }

  // const getVideoUrl = async (rawImg: string, previewImg: string) => {
  //   const formData = new FormData();
  //   formData.append("image", rawImg);
  //   formData.append("class_number", 'GG2-P1-C6')
  //   formData.append("student_id", studentDetails.id)

  //   await axios.post(
  //     `https://artsalpha.whjr.one/api/V1/art/videoTransform`,
  //     formData,
  //     {
  //       headers:
  //         {
  //           'Content-Type': 'multipart/form-data'
  //         }
  //     }
  //   ).then((response) => {
  //       const { data } = response.data;
  //       firebaseRef.update({
  //           videoPoster: previewImg,
  //           videoUrl: data
  //       });

  //   }).catch((error) => {
  //       console.log(error)
  //       socket.emit('message', {className: className, id: studentId, message: { screen: 'uploadArtWorkScreen', isVideoProcessing: false }})
  //   });
  // }

  // const handleUpload = (e: any) => {
  //   socket.emit('message', {className: className, id: studentId, message: { screen: 'UploadMp4Screen', isFileUploading: true }})

  //   const rawImg = e.target.files[0]

  //   // if (e.target.files.length) {
  //   //     getVideoUrl(rawImg, URL.createObjectURL(e.target.files[0]))
  //   // }

  //   let name = `students/${studentDetails.id}/lesson-presentations/in-en-gg2-aav-trial-lpd-m1/VideoFile`;
  //   let storageRef = firebaseStorage.ref("/videoFiles/" + name.concat('.gif'));
  //   let uploadTask = storageRef.put(rawImg);

  //   uploadTask.on(
  //     "state_changed",
  //     (snapshot: any) => {
  //       let progress =(snapshot.bytesTransferred / snapshot.totalBytes) * 100;

  //       switch (snapshot.state) {
  //         case firebase.storage.TaskState.PAUSED: // or 'paused'
  //         console.log("Upload is paused");
  //         break;
  //         case firebase.storage.TaskState.RUNNING: // or 'running'
  //         console.log("Upload is running");
  //         break;
  //       }
  //     },
  //     (error: any) => {
  //       console.log('Error: ', error.message)
  //     },
  //     () => {
  //       uploadTask.snapshot.ref.getDownloadURL().then((downloadURL: any) => {
  //         socket.emit('message', {className: className, id: studentId, message: { screen: 'UploadMp4Screen', isFileUploading: false }})
  //         firebaseRef.update({
  //           videoUrl: downloadURL,
  //         });
  //         Reveal.next();
  //       });
  //     }
  //   )
  // }

  const handleUpload = (e: any) => {
    // socket.emit('message', {className: className, id: studentId, message: { screen: 'UploadMp4Screen', isFileUploading: true }})
    sendSocketMessage({ state: { isFileUploading: true }, action: 'UploadMp4Screen'})
    setIsFileUploading(true)


    const rawImg = e.target.files[0]

    // if (e.target.files.length) {
    //     getVideoUrl(rawImg, URL.createObjectURL(e.target.files[0]))
    // }

    let name = `students/${studentDetails.id}/lesson-presentations/in-en-gg2-aav-trial-lpd-m1/studentOutputGif`;
    let storageRef = firebaseStorage.ref("/GifFiles/" + name.concat('.gif'));
    let uploadTask = storageRef.put(rawImg);

    uploadTask.on(
      "state_changed",
      (snapshot: any) => {
        let progress =(snapshot.bytesTransferred / snapshot.totalBytes) * 100;

        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
          console.log("Upload is paused");
          break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
          console.log("Upload is running");
          break;
        }
      },
      (error: any) => {
        console.log('Error: ', error.message)
      },
      () => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL: any) => {
          // socket.emit('message', {className: className, id: studentId, message: { screen: 'UploadMp4Screen', isFileUploading: false }})
          sendSocketMessage({ state: { isFileUploading: false }, action: 'UploadMp4Screen'})
          const mainUiData = {
            data: {
              artAssetToUpdate: {
                fileName: 'studentOutputGif.gif', // optional
                url: downloadURL, // *required
                fileType: '.gif', // .pdf, .png, .jpg, .gif, .mp4
                assetType: 'image' // *required (image, video, pdf, link, bcbook)
              }
            }
          }

          window.parent.postMessage(mainUiData, "*")
          // window.parent.postMessage({
          //   data: {
          //     artAssetToUpdate: {
          //       fileName: 'studentOutputGif', // optional
          //       url: downloadURL, // *required
          //       fileType: '.gif', // .pdf, .png, .jpg, .gif, .mp4
          //       assetType: 'gif' // *required (image, video, pdf, link, bcbook)
          //     }
          //   }
          // })
          setIsFileUploading(false)
          firebaseRef.update({
            studentOutputGifUrl: downloadURL,
          });
          Reveal.next();
        });
      }
    )
  }


  const showUploadView = () => {
    return (
      <div className={styles.container}>
        <div className={styles.heading}>
          {heading || 'Upload Project File'}
        </div>
        <div className={styles.imagesContainer}>
          <img
            src={uploadIcon}
            alt='mascot'
            className={styles.image}
          />
        </div>
        <div className={artWorkStyles.button} onClick={triggerInput}>
          UPLOAD
        </div>
        <input type="file" id="mp4fileInput" name={'mp4'} accept='image/gif' style={{ display: "none" }} onChange={handleUpload}></input>
      </div>
    )
  }

  const LoadingView = () => {
    return (
      <div className={styles.container}>
        <div className={artWorkStyles.text}>
          Loading...
        </div>
        <img src={blueLoader} alt="Uploading" className={artWorkStyles.loadingImage}/>
      </div>
    )
  }

  return (
    <div>
      { !isFileUploading ? showUploadView() : LoadingView() }
    </div>
  )
}


export default UploadMp4Screen
